import { useState, useEffect } from 'react';
import { Table } from 'components/Table';
import { CustomActionsBoxCollections } from '../../../components/Table/DataView/CustomActionsBoxCollections';
import { adminAPI } from 'services/admin';
import { Box } from '@mui/material';

export const ExpandedCollectionsNew = ({
  id,
  version,
  columns,
  status,
  trigger,
  expanded,
  setNotify,
}) => {
  useEffect(() => {
    if (id === trigger) {
      toggleRow(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger, expanded]);

  const [originalData, setOriginalData] = useState([]);
  const [dataVersions, setDataVersions] = useState([]);
  const [isLoad, setIsLoad] = useState(false);

  const toggleRow = async rowId => {
    if (dataVersions.length === 0) {
      setIsLoad(true);
      setDataVersions([]);
      try {
        const path = `/admin/collections/${rowId}/versions`;
        const response = await adminAPI.get(path);
        setIsLoad(false);
        setOriginalData(response.versionList);
        const firstTenVersions = response.versionList.slice(0, 10);
        setDataVersions(firstTenVersions);
      } catch (error) {
        setIsLoad(false);
        console.log(error);
      }
    } else {
      setIsLoad(false);
    }
  };

  return (
    expanded && (
      <>
        {status && isLoad && (
          <Table.TableRow>
            <Table.TableCell
              align="left"
              colSpan={20}
              style={{ color: 'blue' }}>
              Carregando...
            </Table.TableCell>
          </Table.TableRow>
        )}

        <>
          {dataVersions.map(rowData =>
            dataVersions.length > 1 &&
            rowData.version !== version &&
            !isLoad ? (
              <Table.TableRow
                className="row_version_body"
                hover
                tabIndex={-1}
                key={rowData.id} // Assuming rowData has an id property
                // onClick={() => toggleRow(rowData.id)}
              >
                {columns.map(column => {
                  const value = rowData[column.field];
                  return (
                    <Table.TableCell
                      key={column.field}
                      align={column.align || 'center'}
                      sx={{
                        minWidth: column.minWidth,
                        height: column.height || '49px',
                        maxWidth: column.maxWidth,
                        width: column.width,
                        padding: column.type === 'expanded' ? '0px' : '8px',
                      }}>
                      {(() => {
                        switch (column.type) {
                          case 'expanded':
                            return (
                              <Box className="table-videos-row">
                                <Box className="video_version_line">
                                  <Box className="video_version_right_line"></Box>
                                </Box>
                                <Box className="video_version_line">
                                  <Box className="video_version_bottom_line"></Box>
                                </Box>
                                <Box className="video_version_dot"></Box>
                              </Box>
                            );

                          case 'actions-collections':
                          case 'actions-collections-new':
                            return (
                              <>
                                <CustomActionsBoxCollections
                                  data={rowData}
                                  setNotify={setNotify}
                                />
                              </>
                            );
                          default:
                            return column.render
                              ? column.render(value, rowData)
                              : value;
                        }
                      })()}
                    </Table.TableCell>
                  );
                })}
              </Table.TableRow>
            ) : (
              dataVersions.length === 1 &&
              !isLoad && (
                <Table.TableRow className="row_version_body">
                  <Table.TableCell align="left" colSpan={20}>
                    Não foram encontradas outras versões para o título:{' '}
                    <span className="version_title_bold">{rowData.title}</span>
                  </Table.TableCell>
                </Table.TableRow>
              )
            )
          )}
          {originalData.length > 10 &&
            !isLoad &&
            originalData.length !== dataVersions.length && (
              <Table.TableRow>
                <Table.TableCell align="left" colSpan={20}>
                  <Box
                    onClick={() => setDataVersions(originalData)}
                    sx={{ cursor: 'pointer', color: '#1462A5' }}>
                    Mostrar versões anteriores
                  </Box>
                </Table.TableCell>
              </Table.TableRow>
            )}
        </>
      </>
    )
  );
};
